/** Permission strings aligned with backend api/permissions/constants.py
 *
 * MAINTAIN: When changing permissions or system roles, also update
 * docs/permissions-and-system-roles.md (see annotated files listed there).
 */

export const PERMS = {
    ORGANIZATIONS_VIEW: 'organizations.view',
    ORGANIZATIONS_EDIT: 'organizations.edit',
    ORGANIZATIONS_MANAGE_USERS: 'organizations.manage_users',
    ORGANIZATIONS_MANAGE_ROLES: 'organizations.manage_roles',
    PROJECTS_VIEW: 'projects.view',
    PROJECTS_CREATE: 'projects.create',
    PROJECTS_EDIT: 'projects.edit',
    PROJECTS_DELETE: 'projects.delete',
    PROJECTS_ARCHIVE: 'projects.archive',
    PROJECTS_ADD_CUSTOMERS: 'projects.add_customers',
    PROJECTS_REMOVE_CUSTOMERS: 'projects.remove_customers',
    TRANSACTIONS_VIEW: 'transactions.view',
    TRANSACTIONS_VIEW_LIMITED: 'transactions.view_limited',
    TRANSACTIONS_CREATE: 'transactions.create',
    TRANSACTIONS_EDIT: 'transactions.edit',
    TRANSACTIONS_DELETE: 'transactions.delete',
    TRANSACTIONS_APPROVE: 'transactions.approve',
    TRANSACTIONS_EXPORT: 'transactions.export',
    TRANSACTIONS_RECONCILE: 'transactions.reconcile',
    INVOICES_VIEW: 'invoices.view',
    INVOICES_VIEW_LIMITED: 'invoices.view_limited',
    INVOICES_CREATE: 'invoices.create',
    INVOICES_EDIT: 'invoices.edit',
    INVOICES_DELETE: 'invoices.delete',
    INVOICES_SYNC: 'invoices.sync',
    SUPPLIERS_VIEW: 'suppliers.view',
    SUPPLIERS_CREATE: 'suppliers.create',
    SUPPLIERS_EDIT: 'suppliers.edit',
    SUPPLIERS_DELETE: 'suppliers.delete',
    DOCUMENTS_VIEW: 'documents.view',
    DOCUMENTS_UPLOAD: 'documents.upload',
    DOCUMENTS_EDIT: 'documents.edit',
    DOCUMENTS_ARCHIVE: 'documents.archive',
    DOCUMENTS_DELETE: 'documents.delete',
    PROJ_BUDGETS_VIEW: 'proj_budgets.view',
    PROJ_BUDGETS_CREATE: 'proj_budgets.create',
    PROJ_BUDGETS_EDIT: 'proj_budgets.edit',
    PROJ_BUDGETS_DELETE: 'proj_budgets.delete',
    ORG_ANALYTICS_VIEW: 'org_analytics.view',
    PROJ_ANALYTICS_VIEW: 'proj_analytics.view',
    PROJ_DATAFIELDS_VIEW: 'proj_datafields.view',
    PROJ_DATAFIELDS_PUBLIC_VIEW: 'proj_datafields.public_view',
    PROJ_DATAFIELDS_CREATE: 'proj_datafields.create',
    PROJ_DATAFIELDS_EDIT: 'proj_datafields.edit',
    PROJ_DATAFIELDS_DELETE: 'proj_datafields.delete',
    VENDOR_QUOTES_VIEW: 'vendor_quotes.view',
    VENDOR_QUOTES_SUBMIT: 'vendor_quotes.submit',
    VENDOR_PROFILE_EDIT: 'vendor_profile.edit',
};
